import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'footer[app-account-footer]',
  imports: [RouterModule],
  templateUrl: './account-footer.html',
  styleUrl: './account-footer.scss',
})
export class AccountFooter {}
